import moment from "moment";
import type { Stop } from "@api/graphql/generated/generated-types";

function formatCompletedAtHint(completedAt: number): string {
  return `Completed: ${moment.unix(completedAt).format("MMM D, YYYY h:mm A")}`;
}

export function getManualArrivalReferenceHint(
  task: NonNullable<Stop["tasks"]>[number],
  stop: Stop,
): string | null {
  if (task.arrivedAt) {
    if (stop.completedAt != null)
      return formatCompletedAtHint(stop.completedAt);
    return null;
  }
  if (stop.completedAt != null) return formatCompletedAtHint(stop.completedAt);
  if (task.date) return `Task date: ${moment(task.date).format("MMM D, YYYY")}`;
  return null;
}
